<template>
    <div id="industry"  :style="{width:clientW+'px',height:clientH+'px'}" style="margin:0 auto">
        
    </div>
</template>
<script>
export default {
    data(){
        return{
            clientW:document.body.clientWidth,
            clientH:document.body.clientHeight,
            imgPath:imgPath
        }
    },
    created(){
        this.getViewScale();
    },
    methods: {
         getViewScale(){
            if(this.clientW >= 750){
                this.clientW = 414;
                this.clientH = 730;
            }
            if(this.clientH/this.clientW > 1.5 && this.clientH/this.clientW < 1.6){
                this.screenParm = "smallScreen";
            }else if(this.clientH/this.clientW <= 1.5){
                this.screenParm = "superSmallScreen";
            }else if(this.clientH/this.clientW >= 1.8){
                this.screenParm = "bigScreen";
            }else{
                this.screenParm = "middleScreen";
            }
        }
    },
}
</script>
<style lang="less" scoped>
 @base:46.875rem;
#industry{
    background-image: url(https://t.shundecity.com/shzstjh2021/Home/View/Index/images/otherbg.png);
    background-size: 100% 100%;
}   
</style>


// WEBPACK FOOTER //
// src/pages/Industry.vue